import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface FilterBarV2State {
  filterDrawerOpen: boolean;
}

const initialState: FilterBarV2State = {
  filterDrawerOpen: false,
};

const filterBarV2Slice = createSlice({
  name: 'filterBarV2',
  initialState,
  reducers: {
    setFilterDrawerOpen: (state, action: PayloadAction<boolean>) => {
      state.filterDrawerOpen = action.payload;
    },
    toggleFilterDrawer: (state) => {
      state.filterDrawerOpen = !state.filterDrawerOpen;
    },
  },
});

export const { setFilterDrawerOpen, toggleFilterDrawer } = filterBarV2Slice.actions;

export default filterBarV2Slice.reducer;
